import styled from '@emotion/styled';

// The Reviewer Dashboard is a wide data table -- like Fraud Reporting it needs
// more room than the narrower shared containers give it, otherwise it leaves
// visible empty gutters on wide monitors. Same margin/padding rhythm, wider max.
export const PageContentReviewerDashboard = styled.div`
  margin: 79px auto 60px;
  padding: 0 24px;
  max-width: 1800px;
  @media screen and (max-width: 600px) {
    padding: 0 16px;
    margin-top: 60px;
  }
`;

export default PageContentReviewerDashboard;
